import { Component, OnInit } from '@angular/core';
import { AlertService } from '@mp-core/services/alert.service';
import { ErrorService } from '@mp-core/services/error.service';
import { Unsubscribe } from '@mp-app/unsubscribe';
import { takeUntil } from 'rxjs/operators';
import { Constants } from '@mp-core/enums/constants';
import { AuthService } from '@mp-core/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent extends Unsubscribe implements OnInit {
  title = 'medpad-website';

  constructor(private alertService: AlertService, private errorService: ErrorService, private authService: AuthService) {
    super();
  }

  ngOnInit() {
    if (!!localStorage.getItem(Constants.AUTH_TOKEN)) {
      this.authService.autoLogin();
    }
    this.errorService.all().pipe(takeUntil(this._destroyed$)).subscribe((err) => {
      console.log(err);
      this.alertService.error(err.detail);
    });
  }
}
